/**
 * @file
 * Handle the common map.
 */

(function ($) {
  "use strict";

  Drupal.behaviors.matchHeight = {
    attach: function (context, settings) {
      $(function() {
        $('.js-match-height', context).matchHeight();

        $.fn.matchHeight._afterUpdate = function(event, groups) {
          $(window).trigger('items-resized', event, groups);
        }
      });
    }
  };

})(jQuery);
